import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP__SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    // release = git-SHA, beim Build injiziert (REACT_APP__SENTRY_RELEASE), damit
    // Sentry Fehler ↔ Deploy korrelieren kann. Leer (lokaler Build) => kein
    // release-Tag, kein Fehler. CRA inlined REACT_APP_*-Vars zur Build-Zeit.
    release: process.env.REACT_APP__SENTRY_RELEASE || undefined,
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
}

export { Sentry };
